<template>
    <div>
        <van-nav-bar
                :title="title"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
        />
        <mavon-editor :toolbarsFlag="false" :subfield="false" defaultOpen="preview" :navigation="false"
                      v-model="content" :codeStyle="markdown.codeStyle"/>
    </div>
</template>

<script>

    export default {
        name: "Wp_jd_content",
        data() {
            return {
                content: '',
                title: '',
                markdown: {
                    codeStyle: 'atom-one-dark',
                }
            }
        },
        created() {
            let aid = this.$common.getUrlKey("aid");
            let cid = this.$common.getUrlKey("cid");
            this.loadContent(aid, cid);
        },
        methods: {
            loadContent(aid, _cid) {
                this.$log(_cid);
                let that = this;
                let list = this.$article_config.helpList;
                if (_cid && _cid === 'course') {
                    list = this.$article_config.guideList;
                }
                if (_cid && _cid === 'rule') {
                    list = this.$article_config.ruleList;
                }
                let url = list[aid];
                let _title = url.substring(url.lastIndexOf("/") + 1, url.length).replace(".md", '');
                this.title = _title;
                this.$get(url).then(function (response) {
                    let _content = response;
                    that.content = _content;
                })
            },
            onClickLeft() {
                // history.go(-1);
                this.$common.is_from_article_content = "true"
                this.$router.back(-1);
            }
        }
    }
</script>

<style scoped>

</style>